import app from '@/AppData'
import util from '@/utils/util'
import lubanapi from '@/lubanapi'
import {LAST_ACCOUNT_ID, SERVICE_SWITCH} from '@/utils/const'
import appData from './AppData'

const ENV = require('@/env.js')
const TAG = 'jsbridge'
const SPFileName = 'aicall'
const SP_KEY_LEFT_TRY_TIMES = 'left_try_times'
const SP_KEY_SHOW_NOTIFICATION = 'show_notification'
const SP_KEY_BIND_NUM = 'bindnum'

// 所有与客户端相关的接口，新产品接入时需要适配
function getImie () {
  console.log(TAG, 'getImie')
  return Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('getInfo', {
        key: 'imie'
      }, function (res) {
        if (res.err_msg === 'ok') {
          console.log('获取imie成功，value: ' + res.ret)
          resolve(res.ret)
        } else {
          console.log('获取imie失败，value: ' + res.ret)
          reject(null)
        }
      })
    } catch (err) {
      console.log('获取imie失败，err: ' + JSON.stringify(err))
      reject(null)
    }
  })
}

function getGuid () {
  if (ENV.MOCK) {
    return Promise.resolve('12456')
  }
  console.log(TAG, 'getGuid')
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('getInfo', {
        key: 'guid'
      }, function (res) {
        if (res.err_msg == 'ok') {
          console.log('获取guid成功，value: ' + res.ret)
          resolve(res.ret)
        } else {
          resolve('')
        }
      })
    } catch (err) {
      console.log('获取guid失败，err: ' + JSON.stringify(err))
      resolve('')
    }
  })
}

function setAiRedirectCall (num) {
  console.log(TAG, 'setAiRedirectCall', num)
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('setAiRedirectCall', {
        num: num
      }, function (res) {
        console.log(TAG, 'setAiRedirectCall', res)
        if (res.err_msg == 'ok' && res.value == 'true') {
          resolve()
        } else {
          reject()
        }
      })
    } catch (err) {
      console.log(TAG, 'setAiRedirectCall，err: ' + JSON.stringify(err), err)
      reject('')
    }
  })
}

function getAccountId () {
  if (ENV.MOCK) {
    return Promise.resolve(10000)
  }
  console.log(TAG, 'getAccountId')
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('getMainAccountInfo', {}, function (res) {
        console.log(TAG, 'getAccountId', res)
        if (res.ret === 0) {
          if (res.state === 'online' && res.accountid !== undefined) {
            console.log('已登录，\nid: ' + res.accountid + '\n管家Token:' + res.token)
            // 把token存下来
            appData.setData('token', res.token)
            if (res.phone) {
              reject('phone')
            } else {
              var lastAccountId = app.getLocalStorage(LAST_ACCOUNT_ID)
              // 判断账号是否有变化
              console.log(TAG, 'getAccountId lastAccountId', lastAccountId, 'res.accountid', res.accountid)
              if (lastAccountId && lastAccountId !== res.accountid) {
                app.putLocalStorage('LubanInfo', null)
                app.setNeedRelogin(true)
                console.log(TAG, 'remove LubanInfo')
              }

              if (res.uin === undefined || res.uin === null) {
                console.log('uin为空！')
                reject(null)
              } else {
                resolve(res.accountid)
              }

              app.putLocalStorage(LAST_ACCOUNT_ID, res.accountid)
              if (res.uin !== undefined) {
                app.getData().uin = res.uin
              }
              if (!util.isEmpty(res.qq_nickname)) {
                app.getData().accountName = res.qq_nickname
              }
              if (!util.isEmpty(res.qq_faceUrl)) {
                app.getData().accountFaceUrl = res.qq_faceUrl
              }

              if (!util.isEmpty(res.wx_nickname)) {
                app.getData().accountName = res.wx_nickname
              }
              if (!util.isEmpty(res.wx_faceUrl)) {
                app.getData().accountFaceUrl = res.wx_faceUrl
              }
            }
          } else {
            console.log('未登录！')
            reject(null)
          }
        } else {
          console.log('err_msg: ' + res.err_msg + ' res.ret: ' + res.ret)
          reject(null)
        }
      })
    } catch (err) {
      console.log('未登录，err: ' + err)
      reject(err)
    }
  })
}

function searchNums (nums) {
  console.log(TAG, 'searchNums')
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('searchNums', {
      nums: nums
    }, function (res) {
      console.log(TAG, 'searchNums res ', res)
      if (res.err_msg === 'ok' && res.ret === 0) {
        resolve(res)
      } else {
        reject(null)
      }
    })
  })
}

function writeSp (spFileName, key, value) {
  console.log(TAG, 'writeSp')
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('writeSp', {
      spFileName: spFileName,
      key: key,
      value: value
    }, function (res) {
      console.log(TAG, 'writeSp res ', res)
      if (res.err_msg == 'ok' && res.ret == 0) {
        resolve(res)
      } else {
        reject(null)
      }
    })
  })
}

function getSp (SPFileName, key) {
  console.log(TAG, 'getSp')
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('getSp', {
      spFileName: SPFileName,
      key: key
    }, function (res) {
      console.log(TAG, 'getSp res ', res)
      if (res.err_msg == 'ok' && res.ret == 0) {
        resolve(res.value)
      } else {
        reject(null)
      }
    })
  })
}

function setBindNum (num) {
  if (util.isEmpty(num)) {
    num = ''
  }
  return writeSp(SPFileName, SP_KEY_BIND_NUM, JSON.stringify(num))
}

function setServiceSwitch (value) {
  return writeSp(SPFileName, SERVICE_SWITCH.NAME, JSON.stringify(value))
}

function checkNeedShowNotification () {
  getSp(SPFileName, SP_KEY_SHOW_NOTIFICATION).then(res => {
    console.log(TAG, 'checkNeedShowNotification', res)
    if (res === 'false') {
      app.setShowNotification(false)
    } else {
      app.setShowNotification(true)
    }
  }).catch(fail => {
    console.log(TAG, 'checkNeedShowNotification failed', fail)
  })
}

function setShowNotification (show) {
  return writeSp(SPFileName, SP_KEY_SHOW_NOTIFICATION, JSON.stringify(show))
}

function setLeftTryTimes (times) {
  return writeSp(SPFileName, SP_KEY_LEFT_TRY_TIMES, JSON.stringify(times))
}

function getStatusBarHeight () {
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('getStatusBarHeight', {}, function (res) {
      console.log(TAG, 'getStatusBarHeight res ' + JSON.stringify(res))
      if (res.err_msg == 'ok' && res.ret == 0) {
        resolve(res)
      } else {
        reject(null)
      }
    })
  })
}

function loginApp () {
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('login', {}, function (res) {

      console.log('login res ' + JSON.stringify(res))
      if (res.err_msg == 'ok' && res.ret == 0) {
        resolve(res)
      } else {
        reject(null)
      }
    })
  })
}

/**
 * 获取小票据
 * @param id
 * @returns {Promise<string>|Promise<*>}
 */
function getActToken (id) {
  if (ENV.MOCK) {
    return Promise.resolve('token')
  }
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('getActToken', {
      id: id
    }, function (res) {
      if (res.err_msg === 'ok' && res.ret === 0) {
        var token = res.token
        console.log('获取活动token成功\n' +
          'token: ' + token)
        resolve(token)
      } else {
        console.log('获取活动token失败\n' +
          'err_msg: ' + res.err_msg + '\n' +
          'res.ret: ' + res.ret)
        reject(null)
      }
    })
  })
}

/**
 * 获取用户的vip信息，确认登录以后才会获取
 * 三个参数
 *{
 *   vipStatus:   0 非会员， 1 正在会员期，2 会员已经过期
 *   expireTime： 会员过期时间
 *}
 */
function getVipInfo (refresh) {
  if (ENV.MOCK) {
    return new Promise((resolve, reject) => {
      let res = {
        vipStatus: 0,
        expireTime: new Date().getTime() + 24 * 60 * 60
      }
      if (res.expireTime !== 0 && res.vipStatus === 0 && res.expireTime - res.currentTime <= 0) {
        res.vipStatus = 2
      }
      res.isLimit = res.vipStatus != 1 ? 1 : 0
      if (res.isLimit) {
        res.limit = {
          cnt: 3
        }// 默认看过三条，联网再查询总条数
      }
      resolve(res)
    })
  } else {
    // TODO 同步有bug，限制调用评率，短时间内调用 直接返回缓存
    return new Promise((resolve, reject) => {
      console.log(TAG, 'getVipInfo from bridge')
      try {
        TcsJSBridge.invoke('getVipInfo', {}, function (res) {
          console.log(TAG, 'getVipInfo res', res)
          if (res.err_msg == 'ok' && res.ret == 0) {
            if (res.vipStatus === 0 && res.expireTime > 0) {
              res.vipStatus = 2
            }
            resolve(res)
          } else {
            resolve({
              vipStatus: 0,
              expireTime: 0
            })
          }
        })
      } catch (err) {
        console.err(TAG, 'getVipInfo', err)
        resolve(app.getData().vipInfo)
      }
    })
  }
}

function openVip (context) {
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('openVip', {}, function (res) {
      console.log(TAG, 'openvip res', res)
      if (res.err_msg == 'ok' && res.ret == 0) {
        getVipInfo(true).then(vipInfo => {
          app.setVipInfo(vipInfo)
          if (vipInfo.vipStatus == 1) {
            console.log(TAG, 'openvip need reload')
            context.reload()
            lubanapi.reportseer('AICall_Open_Vip_Success')
          }
        })
      }
    })
  })
}

let hasInitLuban = false

async function initLuban () {
  console.log(TAG, 'initLuban')
  let guid = app.getData().guid
  if (util.isEmpty(guid)) {
    guid = await getGuid()
    app.getData().guid = guid
  }
  console.log(TAG, 'guid', guid)
  if (!hasInitLuban) {
    console.log(TAG, 'initLuban', 'start')
    try {
      const appid = ENV.ISDEV ? ENV.APPID_DEV : ENV.APPID_RELEASE
      const env = ENV.ISDEV ? 'beta' : 'release'
      wx.lb.init({
        env: env,
        appId: appid,
        login () {
          console.log('login')
          const promiseFn = function () {
            return getActToken(appid)
          }
          return util.retryPromise(promiseFn, 10).then(res => {
            console.log('getActToken res', res)
            const value = {
              type: ENV.LUBAN_TYPE,
              accountId: app.getData().accountId,
              guid: guid,
              token: res,
              platformType: app.getPlatFormType(),
              uin: app.getData().uin
            }
            console.log(JSON.stringify(value))
            return Promise.resolve(value)
          }).catch(err => {
            console.log('获取token id失败请刷新重试', err)
          })
        }
      })
      hasInitLuban = true
    } catch (err) {
      console.log(TAG, err)
    }
  } else {
    console.log(TAG, 'initLuban', 'hasInit')
  }
}

function backOrExit () {
  return new Promise((resolve, reject) => {
    TcsJSBridge.invoke('goBackOrQuitWeb', {}, function (res) {
      console.log(TAG, 'goBackOrQuitWeb res', res)
      if (res.err_msg === 'ok' && res.ret === 0) {

      }
    })
  })
}

/**
 * 展示接入产品的会员引导弹窗
 */
function showVipGuideDialog (context) {
  // alert('请先开启Vip再操作，TODO')
  console.log(TAG, 'showVipGuideDialog')
  if (!window.alertIsShow) {
    context.$alert({
      title: '信息xxxx',
      close () {
        console.log(TAG, 'showVipGuideDialog', 'close')
      },
      confirm () {
        console.log(TAG, 'showVipGuideDialog', 'confirm')
        openVip(context)
      },
      cancel () {
      }
    })
    window.alertIsShow = true
  }

}

// ============== 常用的native能力 begin =============

/**
 * 显示Toast
 * @param text
 * @returns {*}
 */
function showToast (text) {
  console.log('showToast, text:' + text)
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('showToast',
        {
          text: text
        },
        function (res) {
          if (res.ret == 0) {
            resolve()
          } else {
            reject(null)
          }
        })
    } catch (err) {
      reject(err)
    }
  })
}

function getPlatform () {
  try {
    TcsJSBridge.invoke('platform', {},
      function (res) {
        console.log(TAG, 'getPlatform', res)
        if (res.err_msg == 'ok') {
          app.setPlatform(res.ret)
        } else {
        }
      })
  } catch (err) {
  }
}

// private static final String API_checkNotificationPermission = "API_checkNotificationPermission";
// private static final String API_openNotificationPermission = "API_openNotificationPermission";

function checkNotificationPermission () {
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('API_checkNotificationPermission', {},
        function (res) {
          console.log(TAG, 'checkNotificationPermission', res)
          if (res.ret == 0 && res.err_msg == 'ok') {
            if (res.value == 'true') {
              resolve(1)
            } else if (res.value == 'false') {
              resolve(0)
            } else {
              resolve(-1)
            }
          } else {
            resolve(-1)
          }
        })
    } catch (err) {
      resolve(-1)
    }
  })
}

function openNotificationPermission () {
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('API_openNotificationPermission', {},
        function (res) {
          console.log(TAG, 'openNotificationPermission', res)
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(null)
          }
        })
    } catch (err) {
      reject(err)
    }
  })
}

function openUrl (url) {
  return new Promise((resolve, reject) => {
    try {
      TcsJSBridge.invoke('openUrl', {url},
        function (res) {
          console.log(TAG, 'openUrl', res)
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(null)
          }
        })
    } catch (err) {
      reject(err)
    }
  })
}

// ============== 常用的native能力 end =============

// 客户端需要实现的js接口
export default {
  getImie,
  getGuid,
  getAccountId,
  loginApp,
  getActToken,
  getVipInfo,
  openVip,
  // doAsyn,
  initLuban,
  showVipGuideDialog,
  showToast,
  searchNums,
  getStatusBarHeight,
  backOrExit,
  writeSp,
  setLeftTryTimes,
  setAiRedirectCall,
  setBindNum,
  setShowNotification,
  checkNeedShowNotification,
  getPlatform,
  checkNotificationPermission,
  openNotificationPermission,
  openUrl,
  setServiceSwitch
}



// WEBPACK FOOTER //
// ./src/jsbridge.js